module.exports = __webpack_public_path__ + "static/media/sihLogo.719bb60f.jfif";